import { Link } from "react-router-dom";
import { TOURNAMENT, WHATSAPP_LINK, MAILTO_LINK } from "@/data/tournament";
import logo from "@/assets/logo.png";

const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="relative bg-[#030303] border-t border-white/10"
    >
      {/* Big logo */}
      <div className="border-b border-white/10 overflow-hidden">
        <div className="max-w-[2000px] mx-auto px-6 py-10 flex items-center justify-center">
          <div className="font-display text-[18vw] leading-none text-white/[0.04] tracking-tighter uppercase select-none">
            PROXIMA · LEAGUE
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img
              src={logo}
              alt="Proxima League"
              className="w-10 h-10 object-contain drop-shadow-[0_0_10px_rgba(234,179,8,0.35)]"
            />
            <span className="font-display text-lg tracking-wider">
              PROXIMA<span className="text-[#EAB308]">·</span>LEAGUE
            </span>
          </div>
          <p className="text-white/50 text-sm font-body leading-relaxed">
            Competición de fútbol 7 amateur de alto nivel. Estructura, prestigio
            y competición en Girona.
          </p>
        </div>

        <div>
          <div className="text-[10px] tracking-[0.3em] uppercase text-white/40 mb-4">
            Sede
          </div>
          <div className="text-white text-sm">{TOURNAMENT.venue}</div>
          <div className="text-white/50 text-sm">Tordera · España</div>
          <div className="text-white/50 text-sm mt-1">25 de Octubre</div>
        </div>

        <div>
          <div className="text-[10px] tracking-[0.3em] uppercase text-white/40 mb-4">
            Navegación
          </div>
          <ul className="space-y-2 text-sm text-white/60">
            <li><a href="/#torneo" className="hover:text-[#EAB308]">El Torneo</a></li>
            <li><a href="/#formato" className="hover:text-[#EAB308]">Formato</a></li>
            <li><a href="/#equipos" className="hover:text-[#EAB308]">Equipos</a></li>
            <li><a href="/#inscripciones" className="hover:text-[#EAB308]">Inscripciones</a></li>
          </ul>
          <div className="text-[10px] tracking-[0.3em] uppercase text-white/40 mb-3 mt-6">
            Legal
          </div>
          <ul className="space-y-2 text-sm text-white/60">
            <li>
              <Link
                to="/politica-devoluciones"
                className="hover:text-[#EAB308]"
                data-testid="footer-link-devoluciones"
              >
                Política de Devoluciones
              </Link>
            </li>
            <li>
              <Link
                to="/politica-cookies"
                className="hover:text-[#EAB308]"
                data-testid="footer-link-cookies"
              >
                Política de Cookies
              </Link>
            </li>
            <li>
              <Link
                to="/politica-privacidad"
                className="hover:text-[#EAB308]"
                data-testid="footer-link-privacidad"
              >
                Protección de Datos
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <div className="text-[10px] tracking-[0.3em] uppercase text-white/40 mb-4">
            Contacto
          </div>
          <a
            href={MAILTO_LINK}
            className="block text-white hover:text-[#EAB308] text-sm break-all"
          >
            {TOURNAMENT.contactEmail}
          </a>
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="block text-white/60 hover:text-[#EAB308] text-sm mt-2"
          >
            WhatsApp directo →
          </a>
          <a
            href="https://www.instagram.com/proximaleague"
            target="_blank"
            rel="noopener noreferrer"
            className="block text-white/60 hover:text-[#EAB308] text-sm mt-2"
            data-testid="footer-link-instagram"
          >
            Instagram @proximaleague →
          </a>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-[10px] tracking-[0.25em] uppercase text-white/30">
          <div>© {new Date().getFullYear()} PROXIMA LEAGUE · Todos los derechos reservados</div>
          <div>Edición I · Girona · 2026</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
